// @flow
import React from 'react';

type Props = {
  strength: ?('weak' | 'acceptable' | 'good' | 'great')
};

export default class PasswordStrength extends React.PureComponent<Props> {
  render() {
    const className = (
      this.props.strength
        ? `password-strength-meter-status-${this.props.strength}`
        : ''
    );

    return (
      <div className={`password-strength-meter ${className}`}>
        <span className="password-strength-meter-level meter-level-weak" />
        <span className="password-strength-meter-level meter-level-acceptable" />
        <span className="password-strength-meter-level meter-level-good" />
        <span className="password-strength-meter-level meter-level-great" />
      </div>
    );
  }
}
